import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-renderer',
  templateUrl: './button-renderer.component.html'
})

export class ButtonRendererComponent implements ICellRendererAngularComp {
  showCreate: boolean;
  showLink: boolean;
  showEmail: boolean;
  showSMS: boolean;
  showDelete: boolean;
  showEdit: boolean;
  showDownload: boolean;

  params;
  label: string;
  disabledCreate = false;
  disabledLink = false;
  disabledEmail = false;
  disabledSMS = false;
  disabledDelete = false;
  disabledEdit = false;
  disabledDownload = false;
  
  agInit(params): void {
    //console.log("button" , params);
    this.params = params;
    this.label = this.params.label || null;
    this.showCreate = this.params.showCreate || false;
    this.showLink = this.params.showLink || false;
    this.showEmail = this.params.showEmail || false;
    this.showSMS = this.params.showSMS || false;
    this.showDelete = this.params.showDelete || false;
    this.showEdit = this.params.showEdit || false;
    this.showDownload = this.params.showDownload || false;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onButtonClick($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.onClick(params);
    }
  }

}
